module.exports = __webpack_public_path__ + "assets/30f733fa4a2fd5097a4525e04221ce92.mp3";